import { ReactNode } from "react";
import { formatDate, parseISODate } from "../../../app/Utils";
import { DocumentStatusLabel } from "../DocumentStatusLabel";
import { DocumentHeader, DocumentStatus } from "../documentsApi";
import { StructureName } from "../../device/Structure";
import { Chip } from "@mui/material";
import { Localized } from "@fluent/react";

interface HeaderFieldProps {
    children: ReactNode;
}
const HeaderField = (props: HeaderFieldProps) => {
    return <div className="px-2 py-1 text-base truncate" >{props.children}</div>;
};

interface HeaderLabelProps {
    children: ReactNode;
}
const HeaderLabel = (props: HeaderLabelProps) => {
    return (
        <div className="text-xs font-bold px-2 py-1 bg-gray-100">
            {props.children}
        </div>
    );
};

export const DocumentFormHeader = ({ doc }: { doc: DocumentHeader }) => {
    const {
        no,
        version,
        title,
        status,
        createdByFullName,
        createDate,
        companyName,
        structureId,
    } = doc;

    const getColor = (status: DocumentStatus) => {
        switch (status) {
            case "N":
                return "info";
            default:
                return "error";
        }
    };

    return (
        <div className="grid grid-cols-[10ch_auto_3ch_minmax(0,3fr)_minmax(0,1fr)_minmax(0,1fr)_auto] border rounded border-gray-300 shadow">
            {/* Nagłówki */}
            <HeaderLabel>
                <Localized id="type">_document</Localized>
            </HeaderLabel>
            <HeaderLabel>
                <Localized id="number">_number</Localized>
            </HeaderLabel>
            <HeaderLabel>V</HeaderLabel>
            <HeaderLabel>
                <Localized id="document-title">_title</Localized>
            </HeaderLabel>
            <HeaderLabel>
                <Localized id="structure">_structure</Localized>
            </HeaderLabel>
            <HeaderLabel>
                <Localized id="company">_company</Localized>
            </HeaderLabel>
            <HeaderLabel>
                <Localized id="status">_status</Localized>
            </HeaderLabel>

            {/* Wartości */}
            <HeaderField>
                <div className="flex flex-col items-start leading-tight">
                    <span className="inline-flex items-center justify-center px-2 py-[1px] rounded border text-xs font-bold">
                        {(doc.type ?? "").toUpperCase()}
                    </span>

                    {doc.documentKind && (
                        <span className="text-[0.7rem] text-gray-500 mt-[2px]">
                            {doc.documentKind}
                        </span>
                    )}
                </div>
            </HeaderField>
            <HeaderField>{no}</HeaderField>
            <HeaderField>{version}</HeaderField>
            <HeaderField>{title}</HeaderField>
            <HeaderField>
                <StructureName structureId={structureId} />
            </HeaderField>
            <HeaderField>{companyName}</HeaderField>
            <HeaderField>
                <Chip
                    label={
                        <DocumentStatusLabel status={status as DocumentStatus} />
                    }
                    color={getColor(status as DocumentStatus)}
                    variant="filled"
                    size="small"
                />
            </HeaderField>
        </div >
    );
};
